import { useEffect, useState } from "react";

export default function HtmlViewer() {
  const [html, setHtml] = useState("");

  useEffect(() => {
    const loadHtml = async () => {
      const baseUrl = process.env.REACT_APP_SSO_REDIRECT_URI;

      const htmlPath = window.location.pathname.replace(/^\/html\//, "");

      const res = await fetch(`${baseUrl}api/html/${htmlPath}`);

      if (!res.ok) {
        setHtml(`<h1>Error ${res.status}</h1>`);
        return;
      }

      setHtml(await res.text());
    };

    loadHtml();
  }, []);

  return (
    <iframe
      title="HTML Viewer"
      srcDoc={html}
      style={{
        width: "100%",
        height: "100vh",
        border: "none",
      }}
    />
  );
}